
import React from 'react'
import {connect} from "react-redux";
import Formulario from '../../framework2/ej2/UI/Formulario'
import { getElementoConfigNombre, getGridConfigNombre} from "../../framework2/ej2/utils/CrudUtilsJPA";

import RolMenus from "./RolMenus";

class FormularioRol extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            rol: null,
        }

        this.gridConfig= getGridConfigNombre("Rol");
        this.elementoConfig= getElementoConfigNombre("Rol");

        this.formulario= React.createRef();
    }

    seleccionado= (elemento) => {
        this.setState({rol: elemento});
    }

    menusAccesiblesGuardados= () => {
        console.log("FormularioRol - menusAccesiblesGuardados");
        console.log("this.formulario: ", this.formulario);
        if (this.formulario && this.formulario.current)
            this.formulario.current.cambiarTabDatos("datos");
    }

    render() {
        const {rol} = this.state;

        return (
                <Formulario icon="take-action" titulo="Roles"
                            ref={this.formulario}
                            gridConfig={this.gridConfig}
                            elementoConfig={this.elementoConfig}
                            onElementoSeleccionado={this.seleccionado}
                            //usuarioCodigo={this.props.auth.usuarioCodigo}
                            usuario={this.props.auth.usuario}
                >
                    <RolMenus titulo="Menús accesibles" enTab={true} rol={rol}
                              onGuardado={this.menusAccesiblesGuardados}/>
                </Formulario>
        )
    }


}

FormularioRol.propTypes = {}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(FormularioRol);



